import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { MailIcon, LockIcon, ArrowLeftIcon } from 'lucide-react';
import { Button } from '../../components/ui/Button';
import { Input } from '../../components/ui/Input';
export function Login() {
  const navigate = useNavigate();
  const [showPassword, setShowPassword] = useState(false);
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    navigate('/feed');
  };
  return <div className="w-full h-full bg-black flex flex-col" data-id="element-221">
      {/* Header */}
      <div className="px-4 py-6 flex items-center" data-id="element-222">
        <button onClick={() => navigate(-1)} className="p-2 -ml-2 text-white hover:bg-surface rounded-full transition-colors" data-id="element-223">
          <ArrowLeftIcon size={24} data-id="element-224" />
        </button>
      </div>

      <div className="flex-1 px-6 pb-6 overflow-y-auto no-scrollbar" data-id="element-225">
        <div className="mb-8" data-id="element-226">
          <h1 className="text-3xl font-poppins font-bold text-white mb-2" data-id="element-227">
            Welcome back!
          </h1>
          <p className="text-softGray" data-id="element-228">Log in to keep the laughs going.</p>
        </div>

        <form onSubmit={handleSubmit} className="flex flex-col gap-5" data-id="element-229">
          <Input label="Email or Phone" placeholder="Enter your email" icon={<MailIcon size={20} data-id="element-231" />} type="email" data-id="element-230" />

          <div className="relative" data-id="element-232">
            <Input label="Password" placeholder="Enter your password" icon={<LockIcon size={20} data-id="element-234" />} type={showPassword ? 'text' : 'password'} data-id="element-233" />
            <button type="button" onClick={() => setShowPassword(!showPassword)} className="absolute right-4 top-[38px] text-softGray text-sm font-medium" data-id="element-235">
              {showPassword ? 'Hide' : 'Show'}
            </button>
          </div>

          <div className="flex items-center justify-between mt-1" data-id="element-236">
            <label className="flex items-center gap-2 text-sm text-softGray cursor-pointer" data-id="element-237">
              <input type="checkbox" className="w-4 h-4 rounded border-border bg-surface text-primary focus:ring-primary focus:ring-offset-black" data-id="element-238" />
              Remember me
            </label>
            <button type="button" onClick={() => navigate('/auth/forgot')} className="text-sm text-primary font-medium" data-id="element-239">
              Forgot password?
            </button>
          </div>

          <Button type="submit" className="mt-4" data-id="element-240">
            Log In
          </Button>
        </form>

        <div className="mt-8 flex items-center gap-4" data-id="element-241">
          <div className="flex-1 h-px bg-border" data-id="element-242"></div>
          <span className="text-sm text-softGray" data-id="element-243">or continue with</span>
          <div className="flex-1 h-px bg-border" data-id="element-244"></div>
        </div>

        <div className="mt-6 flex flex-col gap-3" data-id="element-245">
          <Button variant="secondary" onClick={() => navigate('/feed')} className="flex items-center gap-3" data-id="element-246">
            <div className="w-5 h-5 bg-[#FFFFFF] rounded-full flex items-center justify-center text-[#121212] font-bold text-xs" data-id="element-247">
              G
            </div>
            Google
          </Button>
          <Button variant="secondary" onClick={() => navigate('/feed')} className="flex items-center gap-3" data-id="element-248">
            <div className="w-5 h-5 bg-[#FFFFFF] rounded-full flex items-center justify-center text-[#121212] font-bold text-xs" data-id="element-249"></div>
            Apple
          </Button>
        </div>

        <div className="mt-10 text-center" data-id="element-250">
          <p className="text-softGray text-sm" data-id="element-251">
            Don't have an account?{' '}
            <button onClick={() => navigate('/auth/register')} className="text-primary font-bold" data-id="element-252">
              Sign up
            </button>
          </p>
        </div>
      </div>
    </div>;
}